import React, { useRef, useState } from "react";
// import history from "../RouterWithAcess/history";
import { Toast } from "primereact/toast"
import { InputTextarea } from "primereact/inputtextarea";
import { InputText } from "primereact/inputtext";
import { TabView, TabPanel } from "primereact/tabview";
import { Button } from "primereact/button";
// import async from "../../utils/service.js";
import { Card } from "primereact/card";
import AddOption from "./AddOption";
import { BreadCrumb } from "primereact/breadcrumb";
import { SelectButton } from 'primereact/selectbutton';
import { useNavigate } from "react-router-dom";



function AddAssessment() {
  const navigate = useNavigate
  const myToast = useRef(null);
  // const showSuccessToast = (header, content) => {
  //   myToast.current.show({severity : 'success', summary : header, detail : content, life : 10000})
  // }
  const showWarningToast = (header, content) => {
    myToast.current.show({severity : "warn", summary : header, detail : content, life : 10000})
  }
  // const showErrorToast = (header, content) => {
  //   myToast.current.show({severity : "error", summary : header, detail : content})
  // }

  const [categories, setCategories] = React.useState(["",""])
  const [percentage, setPercentage] = React.useState("Equal")

  const items = [
    { label: "Risk Assessment", url: "/Questionnaires" },
    {
      label:
        "Add Assessmement" 
    },
  ];

  const home = {
    icon: "pi pi-home",
    url: "/",
  };

  const [remainingPercent, setRemaingpercent] = useState(0)

  const initialQuestion = (num) => ({
    questionType: "Radio Type",
    questionName: "",
    options: [{ optionText: "", category : "", minRange: null, maxRange: null},
     { optionText: "", category : "", minRange: null, maxRange: null}],
     weightage : num
  });

  const intialAssessment = (num) => ({
    surveyStartDate: "",
    surveyEndDate: "",
    questions: [initialQuestion(num)],
  })
  
  const [createAssessment, setCreateAssessment] = React.useState(intialAssessment(100));

  const createJSON = () => {
    var AddSurveyJSON = {}

    AddSurveyJSON.surveyType = "Type"
    AddSurveyJSON.surveyDescription = "SurveyDescription"

    var questionList = JSON.parse(JSON.stringify(createAssessment.questions))
    for (var i=0;i<questionList.length;i++){
      if (questionList[i].questionType === "SLIDER"){
        for (var opid=0;opid < questionList[i].options.length; opid++){
          if(questionList[i].options[opid].minRange === null && questionList[i].options[opid].maxRange === null){
            questionList[i]["options"].splice(opid, 1)
          }
        }
      }

    }
    AddSurveyJSON.questions = questionList

    return AddSurveyJSON
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    navigate("/Questionnaires")
    
    const SurveyJson = createJSON()
    if (JSON.stringify(SurveyJson) === JSON.stringify({}) ){return}
      
      // async.saveorUpdateSurvey(SurveyJson)
      // .then(resp => {
      //   console.log("response - ", resp.data)
      //   if (resp.data === "Success"){
      //     // showSuccessToast("Succcess", "Survey created succesfully")
      //     navigate("/poll")
      //   }
      //   else {
      //     showWarningToast("Request Failed", "Survey with same period exists")
      //   }
      // })
      // .catch((error) => {
      //   console.log("error - ", error)
      //   showErrorToast("Request Failed", "Please try again")
      // })
  };

  const deleteQuestion = (index) => {
    const questionList = [...createAssessment.questions];
    questionList.splice(index, 1);
    setCreateAssessment({ ...createAssessment, questions: questionList });
  };

  const addQuestion = () => {
    setCreateAssessment({
      ...createAssessment,
      questions: [...createAssessment.questions, initialQuestion(remainingPercent)],
    });
    setRemaingpercent(0)
  };

  function handleQuestionChange(event, index) {
    let name = event.target.name;
    const questionList = [...createAssessment.questions];

    if (name === "weightage") {
      const change = event.target.value - questionList[index][name]
      if (remainingPercent - change < 0){
        showWarningToast("Warning", "Total weightage is 100%")
        return
      }
      setRemaingpercent(rp => (rp - change))
    }

    questionList[index][name] = event.target.value;



    setCreateAssessment({
      ...createAssessment,
      questions: questionList,
    });
  }

  const deleteOption = (optionId, index) => {
    const questionList = [...createAssessment.questions];
    questionList[index].options.splice(optionId, 1);
    setCreateAssessment({ ...createAssessment, questions: questionList });
  };

  const deleteCategory = (index) => {
    const categories1 = [...categories];
    categories1.splice(index, 1);
    setCategories(categories1);
  };

  const handleCategoryChange = (event, index) => {
    const categories1 = [...categories];
    categories1[index] = event.target.value;
    setCategories(categories1);
  }

  const addOption = (index) => {
    const questionList = [...createAssessment.questions];
    questionList[index].options = [
      ...questionList[index].options,
      {optionText: "", category: ""},
    ];
    setCreateAssessment({
      ...createAssessment,
      questions: questionList,
    });
  };

  const handleOptionChange = (event, optionId, index) => {
    const questionList = [...createAssessment.questions];

    if (event.target.name === "category") {
      questionList[index].options[optionId].category = event.target.value
    }

    else {
      if (questionList[index].questionType === "Range Type"){
        if (optionId === 0){
          questionList[index].options[0].minRange = event.target.value
          
        }
        else{
          questionList[index].options[0].maxRange = event.target.value
        }
      }
      else{
        questionList[index].options[optionId].optionText = event.target.value;
      }
    }

    setCreateAssessment({
      ...createAssessment,
      questions: questionList,
    });
  };

  
  return (
    <div className="app__grid main-box">
      <Toast ref={myToast} baseZIndex={20000}/>
      <BreadCrumb model={items} home={home} style={{marginBottom:"20px"}}/>
      <TabView activeIndex={0}>
        <TabPanel header="Create New Risk Assessment">
          <form onSubmit={handleSubmit} id="poll">
            <div className="p-fluid formgrid grid mb-5">
              <div className="field col md:col-12 sm:col-12">
                <label style={{fontWeight : "bold"}}>Title</label>
                <InputText
                  className="widthFull"
                  required
                />
              </div>

              <div className="field col md:col-9 sm:col-12">
                <label style={{fontWeight : "bold"}}>Description</label>
                <InputTextarea
                  className="widthFull"
                  required
                  rows={3}
                />
              </div>

              <div className="col pl-3 md:col-3 sm:col-12 flex flex-column justify-content-center align-items-start">
                <div className="flex align-items-center mb-2">
                  <div style={{fontWeight : "bold"}}>Percentage:</div>
                  <SelectButton 
                    className = "toggleButton"
                    value={percentage}
                    options={["Equal", "Unequal"]}
                    onChange={(e) => {
                      if (e.target.value !== null){
                        setPercentage(e.value)
                      }
                    }}>
                  </SelectButton>
                </div>

                {/* {
                  percentage === "Unequal" &&
                  <div style={{fontSize : "0.8rem", color:"#d57f00"}}>Remaining Weightage : {remainingPercent}</div>
                } */}
              </div>

              {/* <div className="field col md:col-4 sm:col-12">
                <label>Percentage weight for the questions</label>
                <SelectButton 
                  value={percentage}
                  options={["Equal", "Unequal"]}
                  onChange={(e) => setPercentage(e.value)}>
                </SelectButton>
              </div> */}
              
              <div className="col md:col-3 sm:col-12 p-inputgroup">
                <span style={{fontWeight : "bold"}}>Result Types: {" "}</span>
                
                <Button
                    icon="pi pi-plus"
                    className="btn-primary plusIcon"
                    onClick={() => { setCategories((prev) => [ ...prev,  "" ]) }}
                    type="button"
                  />
                
                {/* <label htmlFor="option" className="label p-inputgroup">
                  Result Categories:{" "}
                  <Button
                    icon="pi pi-plus"
                    className="btn-primary"
                    style={{height : ""}}
                    onClick={() => { setCategories((prev) => [ ...prev,  "" ]) }}
                    type="button"
                  />
                </label> */}
              </div>

              <div className="field col md:col-9 sm:col-12"></div>
              {
                categories.map((category, index) => (
                  <div className="field col md:col-3 sm:col-12">
                    <div className="p-inputgroup">
                      <InputText
                        name="option"
                        type="text"
                        value={category}
                        onChange={(e) => handleCategoryChange(e, index)}
                        required
                      />
                      {
                        categories.length>2 &&
                        <Button
                          onClick={(e) => deleteCategory(index)}
                          icon="pi pi-trash"
                          className=" p-button-danger"
                          type="button"
                        />
                      }
                    </div>
                  </div>))
                }
            </div>

            {createAssessment.questions.map((question, index) => (
              <div>
                {
                  percentage === "Unequal" &&
                  <div className="flex justify-content-end mb-1" style={{fontWeight : "bold"}}><span>Remaining Weightage : {remainingPercent}</span></div>
                }
                
                <Card key={index} className="questionCard">
                  <b style={{fontSize : "1.2rem"}}>Question {index + 1}</b>
                  <div className="p-fluid formgrid grid pt-2">
                    <div className="field col md:col-10 sm:col-12">
                      <label htmlFor="firstname" className="label">
                        <span style={{fontWeight:"bold", fontSize:"0.85rem"}}>* Question Text</span>
                      </label>
                      <InputTextarea
                        rows={2}
                        cols={30}
                        name="questionName"
                        value={question.questionName}
                        onChange={(e) => handleQuestionChange(e, index)}
                        required
                      />
                    </div>

                    <div className="field col md:col-1 sm:col-0"></div>
                    { percentage!=="Equal" &&
                      <div className="field col md:col-1 sm:col-12">
                        <label className="label">
                          <span style={{fontWeight:"bold",  fontSize:"0.85rem"}}>* Weightage</span>
                        </label>
                        <InputText
                          name="weightage"
                          value = {question.weightage}
                          onChange={(e) => handleQuestionChange(e, index)}
                          type="number"
                          min="0"
                          max="100"
                          cols={1}
                          style={{width : "4rem"}}
                          required
                        />
                      </div>
                    }

                    <AddOption
                      index={index}
                      addOption={addOption}
                      question={question}
                      handleOptionChange={handleOptionChange}
                      deleteOption={deleteOption}
                      categories={categories.filter((cat) => cat!=="")}
                    />

                    <div className="field block mx-auto sm:col-12 ">
                      {
                        index === createAssessment.questions.length-1 &&
                        <Button
                          onClick={addQuestion}
                          label="Add Question"
                          className="p-button-sm btn3"
                          type="button"
                        />
                      }
                      {
                        createAssessment.questions.length > 1 &&
                        <Button
                          label="Delete Question"
                          className="p-button-sm btn3"
                          onClick={(e) => deleteQuestion(index)}
                          type="button"
                        />
                      }
                    </div>
                  </div>
                </Card>
              </div>
            ))}
            <Button
              type="submit"
              form="poll"
              label="Save"
              className="p-button-sm btn2 floatRight"
            />
          </form>
        </TabPanel>
      </TabView>
    </div>
  );
}

export default AddAssessment;
